import React from 'react'

const Metabase = () => {
  return (
       <iframe style={{height:"85%",width:"100%",position:"relative",zIndex:"3"}}
    src="http://localhost:12345/public/dashboard/2e651e6f-5eca-4a4e-be93-4bf4be8b311b"
    frameborder="0"
    width="800"
    height="600"
    allowtransparency
></iframe>
  )
}

export default Metabase;